import Vue from 'vue'
import VueRouter from "vue-router";
import PageLanguages from "./pages/PageLanguages";
import PageRoyaume from "./pages/PageRoyaume";
import PageMap from "./pages/PageMap";
import PageFoko from "./pages/PageFoko";
import PageTemp from "./pages/PageTemp";

const router = new VueRouter({
    routes: [
        {
            name:"home",
            path: '/',
            component: PageLanguages
        },
        {
            name:"map",
            path: '/:langCode/map',
            component: PageMap
        },
        {
            name:"royaume",
            path: '/:langCode/royaume/:id',
            component: PageRoyaume
        },
        {
            name:"foko",
            path: '/:langCode/foko/:id',
            component: PageFoko
        },
        {
            name:"temp",
            path: '/:langCode/temp',
            component: PageTemp
        },

    ]
});
Vue.use(VueRouter);
export default router;